import React, {useState} from 'react';

const PoshInputs = (props: any) => {
  return (
    <div style={{marginTop: `${props.suggestedNo ? "24px":0}`}} className="container-fluid">
      <div className="row ">
        <div className="col-md-12 form-group">
          <label htmlFor="validationCustom03" className="form-label mb-0 ml-1 d-flex">
            <span>{props.title}</span>
            <span style={{color: 'red'}}>{props.validate}</span>
          </label>
          <input
            onChange={props.onChange}
            value={props.value}
            required
            disabled={props.disabled}
            type={props.type}
            placeholder={props.title}
            className={`form-control  mt-2 " ${
              props.hideControl && 'hideNumber_controls'
            }`}
            id="validationCustom03"
          />
          <label htmlFor="validationCustom03" style={{marginTop:"-10px"}} className="form-label d-flex justify-content-end">
            <span style={{color: '#0d6efd',fontWeight:"lighter"}}>{props.suggestedNo ? `Suggested no ${props.suggestedNo}` : ""}</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default PoshInputs;
